import Vue from 'vue';
import axios from "axios";
import store from "./store";
import { Toast } from 'bootstrap';
import DOMPurify from "dompurify";
import SessionStorage from '../utilities/SessionStorage';

Vue.prototype.$isLoad = () => store.state.load > 0;

Vue.prototype.$load = (num = -1) => {
    store.commit("load", num === 1 ? 1 : -1);
};

Vue.prototype.$http = axios.create({
    transformRequest: (data, heads) => {
        Vue.prototype.$load(1);
        let fd = data instanceof FormData;
        heads["Content-Type"] = fd ? "multipart/form-data" : "application/json";
        return fd ? data : JSON.stringify(data);
    },
    transformResponse: (data) => {
        Vue.prototype.$load();
        return JSON.parse(data);
    },
});

Vue.prototype.$silentHttp = axios.create({
    transformRequest: (data, heads) => {
        let fd = data instanceof FormData;
        heads["Content-Type"] = fd ? "multipart/form-data" : "application/json";
        return fd ? data : JSON.stringify(data);
    },
    transformResponse: (data) => {
        return JSON.parse(data);
    },
});

Vue.prototype.$http.interceptors.response.use(
    (response) => {
        if (!!response.data.message && response.data.message)
            Vue.prototype.$toastr.s(response.data.message);

        if (!!response.data.error && response.data.error)
            Vue.prototype.$toastr.e(response.data.error);
        return response.data;
    },
    (error) => {
        if (error.response && error.response.data.message)
            Vue.prototype.$toastr.e(error.response.data.message);
        throw error;
    }
);

Vue.prototype.$silentHttp.interceptors.response.use(
    (response) => {
        if (!!response.data.error && response.data.error)
            console.log(response.data.error);
        return response.data;
    },
    (error) => {
        if (error.response && error.response.data.message)
            console.log(error.response.data.message);
        throw new Error("Response");
    }
);

Vue.prototype.$scrollToTop = () => {
    window.scrollTo(0, 0);
};

Vue.prototype.$mandatoryQuestions = [
    {
        question: "Do you currently pay rent",
        answerType: "bool",
        required: "yes",
        Checked: true,
        type: "mandatory",
        index: "rent",
    },

    {
        question: "What is the rent amount for the unit you are applying for?",
        answerType: "text",
        required: "yes",
        Checked: true,
        type: "mandatory",
        index: "rentBudget",
    },
];

Vue.prototype.$mandatoryQuestionsIndex = {
    RES: {
        rent: {
            yes:
            "What is the amount of <b>rent</b> that would appear on your bank statement",
            no: "Your current living situation",
        },

        rentBudget: {
            yes : ""
        }
    },

    COM: {
        rent: {
            yes:
            "What is the amount of <b>rent</b> or <b>mortgage</b> that would appear on your bank statement",
            no: "Your current living situation",
        },
    },
};

Vue.prototype.$defaultQuestions = [
    {
        question: "Will there be a co-applicant on this application",
        answerType: "bool",
        required: "no",
        type: "additionalInfo",
        index: "cosigner",
    },
];

Vue.prototype.$defaultQuestionsIndex = {
    cosigner: {
        yes: {
            name: "Cosigner Name",
            email: "Cosigner Email",
            phone: "Cosigner Phone",
            message: "Message to Cosigner",
        },
        no: "",
    },
};

Vue.prototype.$roommateQuestions = [
    {
        question: "Will you have roommates",
        answerType: "bool",
        required: "no",
        type: "additionalInfo",
        index: "roommate",
    },
];

Vue.prototype.$roommateQuestionsIndex = {
    roommate: {
        yes: {
            name: "Roommate Name",
            email: "Roommate Email",
            phone: "Roommate Phone",
            message: "Message to Roommate",
        },
        no: "",
    },
};

Vue.prototype.$organizations = {
    rentify: "Rentify",
    happy_renter: "Happy Renter",
    leads: "Leads Organization",
};
const toasts = {};

Vue.prototype.$addToast = function (options) {
    try {
        // if options.autoHide is not set, we set it to true by default
        if (typeof options.autoHide === 'undefined') {
            options.autoHide = true;
        }
        // Create the toast element
        const toastEl = document.createElement('div');
        toastEl.classList.add('toast', 'vf-toast', 'position-fixed', 'top-0', 'start-50', 'translate-middle-x', 'mt-2');
        toastEl.setAttribute('role', 'alert');
        toastEl.setAttribute('aria-live', 'assertive');
        toastEl.setAttribute('aria-atomic', 'true');

        // Add the toast header
        const toastHeaderEl = document.createElement('div');
        if (options.header !== false) {
            toastHeaderEl.classList.add('toast-header');
            // Add the title and subtitle

            // if title is not set, we set it to false by default
            if (typeof options.title === 'undefined') {
                options.title = false;
            }
            if (options.title !== false) {
                const titleEl = document.createElement('strong');
                titleEl.classList.add('me-auto');
                titleEl.textContent = options.title || 'Bootstrap';
                toastHeaderEl.appendChild(titleEl);
            }
            // Add the subtitle if requested

            // if subtitle is not set, we set it to false by default
            if (typeof options.subtitle === 'undefined') {
                options.subtitle = false;
            }
            if (options.subtitle !== false) {
                const subtitleEl = document.createElement('small');
                subtitleEl.classList.add('text-muted');
                subtitleEl.textContent = options.subtitle;
                toastHeaderEl.appendChild(subtitleEl);
            }

        }


        // Add the close button if requested

        // if closeButton is not set, we set it to false by default
        if (typeof options.closeButton === 'undefined') {
            options.closeButton = false;
        }
        if (options.closeButton !== false) {
            const closeButtonEl = document.createElement('button');
            closeButtonEl.setAttribute('type', 'button');
            closeButtonEl.classList.add('btn-close');
            closeButtonEl.setAttribute('data-bs-dismiss', 'toast');
            closeButtonEl.setAttribute('aria-label', 'Close');
            toastHeaderEl.appendChild(closeButtonEl);
        }

        toastEl.appendChild(toastHeaderEl);

        // Add the toast body
        const toastBodyEl = document.createElement('div');

    if (options.htmlBody?.trim()) {
        toastBodyEl.innerHTML = DOMPurify.sanitize(options.htmlBody);
    } else if (options.body?.trim()) {
        toastBodyEl.textContent = options.body;
    }
    if (toastBodyEl.innerHTML || toastBodyEl.textContent) {
        toastEl.appendChild(toastBodyEl);
    }

        // Append the toast element to the document body
        document.body.appendChild(toastEl);

        // Create a new Toast instance and show it
        const toast = new Toast(toastEl, {autohide: options.autoHide});
        if (options.name) {
            toast._element.addEventListener('hidden.bs.toast', () => {
                delete toasts[options.name];
            });
        }

        toast.show();

        // Store the Toast instance by its name
        if (options.name) {
            toasts[options.name] = toast;
        }
    } catch (e) {
        console.log(`Error creating toast: ${e.message}`);
    }
};

Vue.prototype.$removeToast = function (name) {
    if (toasts[name]) {
        toasts[name].hide();
        delete toasts[name];
    }
};

Vue.prototype.$delay = function (ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

Vue.prototype.$sessionStorage = SessionStorage;